import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { PageId } from 'constants/pages'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'

export const getXStateConfigWoofzInt1 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellioResumeTarget({
          pages,
          pageIds: {
            certificate: PageId.CERTIFICATE,
            nameEntry: PageId.NAME_ENTRY,
            offer: PageId.OFFER,
            registration: PageId.REGISTRATION,
            report: PageId.REPORT,
          },
        }),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION,
          },
          ...(page.pageId === PageId.EMAIL && {
            PREVIOUS_FLOW_STEP: { target: PageId.DISCOVER_FEEDBACKS },
          }),
        },
      },
    }),
    {},
  ),
  // [PageId.DOWNLOAD_ESA]: {
  //   type: 'final',
  // },
})
